import { COOKIE_CONSENT_ACCEPTED_KEY } from "constants/localStorage";
import { useLocalStorage } from "hooks/useLocalStorage";
import React, { useEffect, useRef } from "react";

export default function CookieConsentModal() {
    const [accepted, setAccepted] = useLocalStorage(COOKIE_CONSENT_ACCEPTED_KEY, false);
    const dialogRef = useRef<HTMLElement | null>(null);

    useEffect(() => {
        if (accepted) {
            return;
        }

        const isDialogTarget = (target: EventTarget | null) =>
            target instanceof Node && !!dialogRef.current?.contains(target);

        const blockInteraction = (event: Event) => {
            if (isDialogTarget(event.target)) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
        };

        const blockKeyboardInteraction = (event: KeyboardEvent) => {
            if (isDialogTarget(event.target)) {
                return;
            }

            blockInteraction(event);
        };

        document.addEventListener("click", blockInteraction, true);
        document.addEventListener("submit", blockInteraction, true);
        document.addEventListener("keydown", blockKeyboardInteraction, true);
        dialogRef.current?.focus();

        return () => {
            document.removeEventListener("click", blockInteraction, true);
            document.removeEventListener("submit", blockInteraction, true);
            document.removeEventListener("keydown", blockKeyboardInteraction, true);
        };
    }, [accepted]);

    if (accepted) {
        return null;
    }

    return (
        <div className="cookie-consent">
            <section
                className="cookie-consent__dialog"
                ref={dialogRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby="cookie-consent-title"
                tabIndex={-1}
            >
                <h2 className="cookie-consent__title" id="cookie-consent-title">
                    Cookies
                </h2>
                <div className="cookie-consent__text">
                    Используя сайт, вы соглашаетесь на обработку данных в Cookies для корректной работы сайта, вашей
                    персонализации и других целей, предусмотренных{" "}
                    <a href="https://cargorun.ru/privacy" target="_blank" rel="noreferrer">
                        Политикой
                    </a>
                </div>
                <button className="cookie-consent__button" type="button" onClick={() => setAccepted(true)}>
                    Понятно
                </button>
            </section>
        </div>
    );
}
